module.exports = __webpack_public_path__ + "img/Mongolia_Badges_01_Experiences1.2dc3e0eb.svg";